// extracted by mini-css-extract-plugin
export var standaloneTable = "_ck-0";
export var standaloneTableWithBodyFill = "_ck-1";
export var withExtraHeader = "_ck-2";